// extracted by mini-css-extract-plugin
export var container = "styles-module--container--0f751";
export var content = "styles-module--content--62dcc";